rdefine('app/products/properties/selectbox',['backbone'],function(Backbone) {
    var OptionView = Backbone.Ribs.View.extend({
        tagName:'option',
        bindings:{
            el:{
                text:'model.name',
                attr:{
                    value: {
                        data: 'model.name'
                    }
                }
            }
        }
    });
    return Backbone.Ribs.View.extend({
        tagName:'select',
        className:'',
        bindings:{
            el:{
                collection:{
                    col:'collection',
                    view:OptionView
                },
                value:{
                    events:'changed.bs.select change'
                }
            }
        },
        currentLanguage:'de',
        initialize:function(options) {
            this.cform = options.cform;
            this.currentLanguage = options.lmodel.get("language");
            this.field = 'property_'+this.model.get("id");
            this.bindings.el.value.data = 'cform.property_'+this.model.get("id");
            var json = JSON.parse(this.model.get("json"));
            //get language
            json = json[this.currentLanguage]?json[this.currentLanguage]:['No select'];

            json = _.map(json,function(name){ return {name:name}; });
            json['test'] = {name:''};
            this.collection = new Backbone.Ribs.Collection(json,{model:Backbone.Ribs.Model});
            setTimeout(function(){
                this.$el.selectpicker();
            }.bind(this),0);

        }
    });
});